import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import LiveTicker from "./components/LiveTicker";
import LiveFeed from "./components/LiveFeed";
import HotRanking from "./components/HotRanking";
import CategoryGrid from "./components/CategoryGrid";
import DeepDive from "./components/DeepDive";
import FaqSection from "./components/FaqSection";
import AboutSection from "./components/AboutSection";
import SubscribeSection from "./components/SubscribeSection";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 flex flex-col">
      <Navbar />
      <main className="w-full flex-1">
        <Hero />
        <LiveTicker />
        <LiveFeed />
        <HotRanking />
        <CategoryGrid />
        <DeepDive />
        <FaqSection />
        <AboutSection />
        <SubscribeSection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}